module.exports = __webpack_public_path__ + "static/assets/d5f5e40952ac08040ee6577e5eb77e09.png";